import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const GroupRoutes = defineRoute({
    home: {
        route: {
            path: "/group",
            component: () => loadView(import("./GroupHome.vue")),
        },
    },
    detail: {
        route: {
            path: "/group/:id",
            component: () => loadView(import("./GroupDetail.vue")),
        },
        build(id: string) {
            return `/group/${id}`;
        },
    },
});
